import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
const bonuses = [{
  num: '1',
  title: 'Der Exam-Vault',
  desc: '10 vollständige Prüfungsmodelle mit detaillierten Lösungen. Eines pro Kernmodul. Druckfertig und sofort einsetzbar.'
}, {
  num: '2',
  title: 'Praxis-Stationen',
  desc: '50 Worksheets mit Kurzfällen für den Unterricht (10–15 Min.). Entwickelt um kritisches Denken zu aktivieren.'
}, {
  num: '3',
  title: 'Master Admin Pack',
  desc: 'Bewertungsraster, Planungsvorlagen und Beurteilungsbögen. Alles was Sie für die Klassenverwaltung brauchen.'
}, {
  num: '4',
  title: 'Bilingual Glossar DE/EN',
  desc: '200 Fachbegriffe auf Deutsch und Englisch. Ideal für bilinguale Klassen am Gymnasium.'
}];
export function BonusSection() {
  return <section className="py-12 px-4" data-id="element-25">
      <div className="max-w-2xl mx-auto" data-id="element-26">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8" data-id="element-27">
          <h2 className="text-2xl sm:text-3xl font-black text-swiss-charcoal mb-4" data-id="element-28">
            Und das ist noch nicht alles.
          </h2>
          <p className="text-lg text-gray-600 font-medium" data-id="element-29">
            Mit Ihrem Kauf erhalten Sie 4 professionelle Toolkits ohne Aufpreis.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4" data-id="element-30">
          {bonuses.map((bonus, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1
        }} className="bg-white border-2 border-swiss-gold/40 rounded-xl p-5 shadow-sm relative overflow-hidden" data-id="element-31">
              <div className="absolute top-0 left-0 w-full h-1 bg-swiss-gold" data-id="element-32" />
              <div className="flex items-center gap-2 mb-3" data-id="element-33">
                <GiftIcon className="w-5 h-5 text-swiss-gold" data-id="element-34" />
                <h3 className="font-bold text-swiss-charcoal" data-id="element-35">
                  BONUS {bonus.num}: {bonus.title}
                </h3>
              </div>
              <p className="text-sm text-gray-600 leading-relaxed" data-id="element-36">
                {bonus.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}